import React, { ChangeEvent, FC, useState, forwardRef, Ref } from "react";
import Input from "../Input/Input";
import IconButton from "../IconButton/IconButton";
import { IconTypes } from "../../libs/Icon";

import styles from "./styles.module.scss";

interface PasswordInputProps {
  error?: string;
  label: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const PasswordInput: FC<PasswordInputProps> = forwardRef(
  ({ onChange, error, label }, ref: Ref<HTMLInputElement>) => {
    const [isShowPass, setIsShowPass] = useState(false);

    return (
      <div className={styles.inputContainer}>
        <label className={styles.inputLabel}>{label}</label>
        <div className={styles.passwordInputContainer}>
          <Input
            type={isShowPass ? "text" : "password"}
            inputType="password"
            onChange={onChange}
            placeholder="At least 8 characters"
            ref={ref} // Forward the ref to the Input component
          />

          {isShowPass ? (
            <IconButton
              buttonProps={{
                onClick: () => setIsShowPass((prev) => !prev),
              }}
              className={styles.passwordIcon}
              type={IconTypes.EYE}
              size={24}
            />
          ) : (
            <IconButton
              buttonProps={{
                onClick: () => setIsShowPass((prev) => !prev),
              }}
              className={styles.passwordIcon}
              type={IconTypes.EYE_OFF}
              size={24}
            />
          )}
        </div>
        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

export default PasswordInput;
